<template>
  <div>
    <filter-manager
      ref="filterRef"
      v-model="filter.model"
      class="mb-4"
      :display-advanced="false"
      :filters="filtersConfig"
      @search="searchByCriteria()"
    />
    <slot name="questionnaire-error" />
    <custom-separator class="my-4" text="Resultado" />
    <custom-result-not-found
      v-if="results.length == 0"
      text="No cuenta con información disponible."
    />
    <div v-for="row of results" :key="row.id">
      <proposal-questionnaire-result
        :data="row"
        :is-read-only="isReadOnly"
        @reload="onSearchHandler"
        @toggle="onUncheckAll"
      />
    </div>
    <pagination
      v-if="showPagination"
      :data="pagination"
      show-text
      @pagination-go-page="goToPageHandler"
    />
  </div>
</template>

<script>
//components

import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import storeMixin from '@/shared/mixins/storeGenerator';
import alertMixin from '@/mixins/alert.mixin.js';
import FilterManager from 'FilterManager';
import ProposalQuestionnaireResult from './ProposalQuestionnaireResult.vue';

//services
import { get } from '@/modules/bidQuestionConfig/api.js';
import { announcementQuestionnaireStatuses } from '@/utils/constants/announcementQuestionnaireStatus';

//constants
const DEFAULT_PAGE_SIZE = 5;

export default {
  name: 'ProposalQuestionnaire',
  components: {
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    FilterManager,
    ProposalQuestionnaireResult,
  },
  mixins: [storeMixin, alertMixin],
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: null,
    },
    areaId: {
      type: Number,
      default: null,
    },
    serviceId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      filter: {
        model: {
          searchText: null,
        },
      },
      pagination: {
        currentPage: 1,
        totalItemCount: 1,
        pageCount: 1,
        count: 1,
        pageSize: DEFAULT_PAGE_SIZE,
      },
      results: [],
    };
  },
  computed: {
    questionnaireConfigId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    showPagination() {
      return this.pagination.totalItemCount > this.pagination.pageSize;
    },
    filtersConfig() {
      return [
        {
          name: 'searchText',
          component: 'CustomInput',
          class: 'col-10',
          placeholder: 'Escriba Número de Cuestionario o Nombre',
          clearable: true,
          icon: 'fas fa-search color-primary-2',
          leftIcon: true,
        },
      ];
    },
  },
  watch: {
    'filter.model.searchText'(val) {
      const empty = val == null || String(val).trim() === '';

      if (empty && this.questionnaireConfigId) {
        this.pagination.currentPage = 1;
        this.onSearchHandler(this.questionnaireConfigId);
      }
    },
  },
  mounted() {
    if (this.questionnaireConfigId) {
      this.onSearchHandler(this.questionnaireConfigId);
    }
  },
  methods: {
    async onSearchHandler(id = null) {
      const payload = {
        id: id || null,
        searchText: this.filter.model.searchText,
        statusId: announcementQuestionnaireStatuses.Published,
        areaId: this.areaId,
        serviceId: this.serviceId,
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      const { data: results = { data: [] } } = await get(payload);
      this.results = results.data.map((x) => ({
        ...x,
        opened: x.id === this.questionnaireConfigId ? true : false,
        checked: x.id === this.questionnaireConfigId ? true : false,
      }));

      this.pagination = {
        ...this.pagination,
        totalItemCount: results.totalItemCount,
        pageCount: results.pageCount,
        currentPage: results.currentPage,
        count: results.count,
      };
    },
    async goToPageHandler(page) {
      this.pagination.currentPage = page;
      await this.onSearchHandler();
    },
    async searchByCriteria() {
      if (!this.filter.model.searchText) {
        this.ShowToast(
          'Atención',
          'Ingrese un criterio de búsqueda válido.',
          'error'
        );
        return;
      }
      await this.onSearchHandler();
    },
    onUncheckAll({ id }) {
      this.questionnaireConfigId = id;
      this.results = this.results.map((x) => ({
        ...x,
        opened: x.id === id,
        checked: x.id === id,
      }));
      if (this.results.every((x) => !x.checked)) {
        this.questionnaireConfigId = null;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .filter-manager {
  background-color: transparent !important;
}
</style>
